// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__3mZGE","content":"Header_content__i8q9e","logo":"Header_logo__1X2WF","storeTitle":"Header_storeTitle__2LJfy"};